export default "__VITE_ASSET__bn2jyDNU__"